import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CalendarioProvider } from '../providers/calendario/calendario';

import { AuthService } from '../services/auth.service';
import { AngularFireModule } from 'angularfire2';
import { FIREBASE_CONFIG } from './firebase.credentials';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { PipesModule } from '../pipes/pipes.module';
// import {FusejsModule} from 'angular-fusejs'
// import { SegnalazioniPage } from '../pages/segnalazioni/segnalazioni';
import { EmailComposer } from '@ionic-native/email-composer';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { ComponentsModule } from '../components/components.module'
import { MeteoComponent } from '../components/meteo/meteo'
import { IonicStorageModule } from '@ionic/storage';
import { Keyboard } from '@ionic-native/keyboard';

// import { SafePipe } from '../pipes/safe/safe'
@NgModule({
  declarations: [
    MyApp,
    // SafePipe
    // SegnalazioniPage
  ],
  imports: [
    BrowserModule,
    CommonModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    IonicModule.forRoot(MyApp, { scrollAssist: false, autoFocusAssist: false }),
    // FusejsModule,
    PipesModule,
    ComponentsModule,
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    MeteoComponent
        // SegnalazioniPage
  ],
  providers: [
    Keyboard,
    StatusBar,
    EmailComposer,
    InAppBrowser,
    SplashScreen,
    AngularFireAuth,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    CalendarioProvider,
    AuthService
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts